export const isAuthenticated = () => {
  if (localStorage.getItem("userToken")) {
    return localStorage.getItem("userToken");
  }
  return false;
};

export const hasAuctionSoftwareDomain = () => {
  const user = JSON.parse(localStorage.getItem("Userdetails"));
  const email = user.email;

  return email.toLowerCase().endsWith("@auctionsoftware.com");
};
